/* eslint-disable class-methods-use-this */
import { del as apiDelete, get, patch, post, put } from 'aws-amplify/api'

import type { PostOperation } from '@aws-amplify/api-rest/dist/esm/types'

import { API_NAME } from '~/constants'
import HttpServiceBase, {
  HttpRequestBase,
  HttpServiceBaseResponse,
} from '~/services/http/models'

class AmplifyHttpService implements HttpServiceBase {
  public async get<T>({ path, query }: HttpRequestBase) {
    const operation = get({
      apiName: API_NAME,
      path,
      options: {
        queryParams: query,
      },
    })

    const { body } = await operation.response
    return body.json() as Promise<HttpServiceBaseResponse<T>>
  }

  public async post<T>({ path, query, payload }: HttpRequestBase) {
    const operation = post({
      apiName: API_NAME,
      path,
      options: {
        queryParams: query,
        body: payload as FormData,
      },
    })
    const { body } = await operation.response
    return body.json() as Promise<HttpServiceBaseResponse<T>>
  }

  public async put<T>({ path, query, payload }: HttpRequestBase) {
    const operation = put({
      apiName: API_NAME,
      path,
      options: {
        queryParams: query,
        body: payload as FormData,
      },
    })

    const { body } = await operation.response
    return body.json() as Promise<HttpServiceBaseResponse<T>>
  }

  public async patch<T>({ path, query, payload }: HttpRequestBase) {
    const operation = patch({
      apiName: API_NAME,
      path,
      options: {
        queryParams: query,
        body: payload as FormData,
      },
    })

    const { body } = await operation.response
    return body.json() as Promise<HttpServiceBaseResponse<T>>
  }

  public async delete<T>({ path, query }: HttpRequestBase) {
    const operation = apiDelete({
      apiName: API_NAME,
      path,
      options: {
        queryParams: query,
      },
    }) as PostOperation

    const { body } = await operation.response
    return body.json() as Promise<HttpServiceBaseResponse<T>>
  }
}

export default AmplifyHttpService
